var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"color":"info"}},[_vm._v(" This field is pulled dynamically from your website or our system. Questions? "),_c('CLink',{on:{"click":_vm.openSupportModal}},[_vm._v(" Contact us ")]),_vm._v(" anytime! ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }